exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n}\r\n\r\n.filter-form {\r\n    margin-top: 20px;\r\n}\r\n\r\n.label-col-1 {\r\n    flex: 0 0 100px;\r\n    min-width: 100px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    margin-bottom: 5px;\r\n    padding-top: calc(.5rem - 3px * 2);\r\n}\r\n\r\n.label-col-2 {\r\n    flex: 0 0 100px;\r\n    min-width: 100px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    margin-bottom: 5px;\r\n    padding-top: calc(.5rem - 3px * 2);\r\n}\r\n\r\n.label-col-3 {\r\n    flex: 0 0 130px;\r\n    min-width: 130px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    margin-bottom: 5px;\r\n    padding-top: calc(.5rem - 3px * 2);\r\n}\r\n\r\n.label-col-4 {\r\n    flex: 0 0 160px;\r\n    min-width: 160px;\r\n    text-align: right;\r\n    padding-right: 10px;\r\n    margin-bottom: 5px;\r\n    padding-top: calc(.5rem - 3px * 2);\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/app/customers/customer-search/customer-search.component.css
// module id = 2484
// module chunks = 1